import PropTypes from "prop-types";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
function SampleSizeWarning({ threshold = 75 }) {
    return (
        <div style={{ display: "flex" }}>
            <WarningAmberOutlinedIcon sx={{ color: "#f44336", fontSize: 18 }} />
            <p
                style={{
                    marginTop: 1,
                    marginBottom: 0,
                    color: "#495057",
                    fontWeight: 600,
                    fontSize: 12,
                }}
            >
                The sample size is below {threshold}, so please interpret the results with caution.
            </p>
        </div>
    );
}
SampleSizeWarning.propTypes = {
    products: PropTypes.array,
    threshold: PropTypes.number,
};

export default SampleSizeWarning;
